import {Controller} from "stimulus"

var delayTimer;
export default class extends Controller {
    static targets = ["searchInput", "results", "classificationId", "form"];

    connect() {
    }

    search() {
        clearTimeout(delayTimer);
        var component = this;
        delayTimer = setTimeout(function () {
            var query = component.searchInputTarget.value.trim();
            if (query.length < 2) {
                component.resultsTarget.classList.add("hidden");
                component.resultsTarget.innerHTML = "";
                return;
            }
            fetch('/classifications/query.json?search=' + encodeURIComponent(query))
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    component.renderResults(data);
                })
                .catch(function (error) {
                    console.warn("Classification search error:", error);
                });
        }, 500);
    }

    renderResults(classifications) {
        var component = this;
        var html = "";
        if (classifications.length === 0) {
            html = '<p class="px-3 py-2 text-sm text-gray-500">No classifications found.</p>';
        } else {
            classifications.forEach(function (c) {
                html += '<button type="button" class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-purple-50" data-action="click->license-type-classification-add#selectClassification" data-classification-id="' + c.id + '">';
                html += '<span class="font-mono text-xs text-gray-500">' + component.escapeHtml(c.code || "") + '</span>';
                html += '<span class="text-gray-900">' + component.escapeHtml(c.name) + '</span>';
                html += '</button>';
            });
        }
        this.resultsTarget.innerHTML = html;
        this.resultsTarget.classList.remove("hidden");
    }

    selectClassification(e) {
        var id = e.currentTarget.getAttribute("data-classification-id");
        this.classificationIdTarget.value = id;
        this.resultsTarget.classList.add("hidden");
        this.searchInputTarget.value = e.currentTarget.querySelector("span:last-child").textContent;
        this.formTarget.submit();
    }

    escapeHtml(text) {
        var div = document.createElement("div");
        div.appendChild(document.createTextNode(text));
        return div.innerHTML;
    }
}
